<style lang="scss">
  @import "../../../scss/variables";

  .myo-input {
    position: relative;

    &.myo-input-block {
      width: 100%;

      input {
        width: 100%;
      }
    }

    &.center {
      input {
        text-align: center;
      }
    }

    .btn-clear {
      position: absolute;
      right: 10px;
      top: 14px;
      font-size: 20px;
      color: #aaa;
      cursor: pointer;
    }

    &.invalid {
      input {
        border-color: lighten($red, 25%);
        background-color: lighten($red, 49%);
      }
    }

    input {
      color: $dark-grey;
      background-color: #fff;
      border: $light-grey 2px solid;
      border-radius: 3px;
      font-size: 14px;
      padding: 14px 18px;
      font-family: 'Roboto', sans-serif;
      font-weight: 500;

      &:active {
        border-color: $blue;
      }

      &:disabled {
        background-color: #eee;
      }

      &:focus {
        border-color: $light-blue;
      }
    }
  }
</style>

<template>
  <div class="myo-input">
    <i v-if="clearable && value !== ''"
       aria-hidden="true"
       class="material-icons btn-clear"
       @click="clear()"
    >cancel</i>
    <input :type="type"
           :value="value"
           @input="updateValue($event.target.value)"
           :maxlength="maxlength"
           :placeholder="placeholder"
           :disabled="disabled"
           :name="name"
           :autocomplete="autocomplete"
           ref="input" >
  </div>
</template>

<script>
  export default {
    props: {
      value: {},
      clearable: {},
      maxlength: {},
      name: {},
      autocomplete: {},
      placeholder: '',
      disabled: false,
      type: {
        default: 'text',
      },
    },

    methods: {
      updateValue(value) {
        this.$emit('input', value);
      },

      clear() {
        this.$emit('input', '');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Input.vue?7de05e98